import { render, staticRenderFns } from "./Esg2.vue?vue&type=template&id=09e1f248&scoped=true"
import script from "./Esg2.vue?vue&type=script&lang=js"
export * from "./Esg2.vue?vue&type=script&lang=js"
import style0 from "./Esg2.vue?vue&type=style&index=0&id=09e1f248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e1f248",
  null
  
)

export default component.exports